import { CgSmartHomeBoiler } from "react-icons/cg";
import {
  VscTools,
  VscChecklist,
  VscQuestion,
  VscInfo,
  VscGlobe,
  VscWorkspaceTrusted,
} from "react-icons/vsc";
import { RiShieldStarLine } from "react-icons/ri";
import { IoWaterOutline, IoPeopleOutline } from "react-icons/io5";
import { BiBath } from "react-icons/bi";
import { MdWaves } from "react-icons/md";
import { GiHouseKeys } from "react-icons/gi";
import { BsBuilding, BsHouse } from "react-icons/bs";
import { AiOutlineFileProtect, AiOutlineFileSearch } from "react-icons/ai";

export const subLinks = [
  {
    page: "Home Services",
    subtitle: "SERVICES",
    subtitleTwo: "BOILER FINANCE",
    linksOne: [
      {
        label: "Boilers",
        icon: <CgSmartHomeBoiler className="navbar-icon" />,
        url: "/boilers",
      },
      {
        label: "Boiler Repairs",
        icon: <VscTools className="navbar-icon" />,
        url: "/boiler-repair",
      },
      {
        label: "Boiler Servicing",
        icon: <VscChecklist className="navbar-icon" />,
        url: "/boiler-service",
      },
      {
        label: "Boiler Cover",
        icon: <RiShieldStarLine className="navbar-icon" />,
        url: "/coming-soon",
      },
      {
        label: "Plumbing",
        icon: <IoWaterOutline className="navbar-icon" />,
        url: "/plumbing",
      },
      {
        label: "Bathrooms",
        icon: <BiBath className="navbar-icon" />,
        url: "/bathrooms",
      },
      {
        label: "Underfloor Heating",
        icon: <MdWaves className="navbar-icon" />,
        url: "/underfloor-heating",
      },
    ],
    linksTwo: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_324/v1643231022/AquaHeat/Navbar%20Images/204835804_4186599861387524_237918655419207262_n_ffmf6f.webp",
      },
    ],
    articles: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280239/AquaHeat/Navbar%20Images/boiler-kitchen1_sugw0v.webp",
        subtitle: "GUIDE",
        title: "The Complete Boiler Buying Guide 2021",
        url: "/boiler-buying-guide",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280254/AquaHeat/Navbar%20Images/smartstat2_ayouwd.webp",
        subtitle: "ARTICLE",
        title: "Do Smart Therostats Help Save Money?",
        url: "/do-smart-thermostats-save-money",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280217/AquaHeat/Navbar%20Images/bathrooms_uzoqlf.webp",
        subtitle: "ARTICLE",
        title: "Checklist For Planning a New Bathroom",
        url: "/checklist-for-planning-a-new-bathroom",
      },
    ],
  },
  {
    page: "Commercial Services",
    subtitle: "SERVICES",
    subtitleTwo: "ACCREDITATION",
    linksOne: [
      {
        label: "Private Rental Sector",
        icon: <GiHouseKeys className="navbar-icon" />,
        url: "/private-rental-sector",
      },
      {
        label: "Landlord Boiler Cover",
        icon: <RiShieldStarLine className="navbar-icon" />,
        url: "/coming-soon",
      },
      {
        label: "Block Management",
        icon: <BsBuilding className="navbar-icon" />,
        url: "/block-management-services",
      },
      {
        label: "Housing Associations",
        icon: <BsHouse className="navbar-icon" />,
        url: "/housing-assocation-services",
      },
      {
        label: "24/7 Support Contracts",
        icon: <VscTools className="navbar-icon" />,
        url: "/support-contracts",
      },
      {
        label: "Insurance Contracts",
        icon: <AiOutlineFileProtect className="navbar-icon" />,
        url: "/insurance-contracts",
      },
    ],
    linksTwo: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_60,w_434/v1642174751/AquaHeat/Navbar%20Images/safe_punaq0.webp",
      },
    ],
    articles: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280493/AquaHeat/Navbar%20Images/lettings_yvzuoq.webp",
        subtitle: "GUIDE",
        title: "Gas Safety Checks For Landlords 2021",
        url: "/boiler-buying-guide",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280254/AquaHeat/Navbar%20Images/smartstat2_ayouwd.webp",
        subtitle: "ARTICLE",
        title: "Do Smart Therostats Help Save Money?",
        url: "/do-smart-thermostats-save-money",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280217/AquaHeat/Navbar%20Images/bathrooms_uzoqlf.webp",
        subtitle: "ARTICLE",
        title: "Checklist For Planning a New Bathroom",
        url: "/checklist-for-planning-a-new-bathroom",
      },
    ],
  },
  {
    page: "Company",
    subtitle: "INFORMATION",
    subtitleTwo: "OUR FAMILY",
    linksOne: [
      {
        label: "Contact Us",
        icon: <VscInfo className="navbar-icon" />,
        url: "/contact-us",
      },

      {
        label: "Partners",
        icon: <VscGlobe className="navbar-icon" />,
        url: "/partners",
      },
      {
        label: "Careers",
        icon: <IoPeopleOutline className="navbar-icon" />,
        url: "/careers",
      },
      {
        label: "AquaHeat Trustpilot",
        icon: <VscWorkspaceTrusted className="navbar-icon" />,
        url: "https://uk.trustpilot.com/review/aquaheatplumbing.co.uk?utm_medium=trustbox&utm_source=Grid",
      },
      {
        label: "FAQ",
        icon: <VscQuestion className="navbar-icon" />,
        url: "/faq",
      },
      {
        label: "Terms & Conditions",
        icon: <AiOutlineFileSearch className="navbar-icon" />,
        url: "/terms-and-conditions",
      },
    ],
    linksTwo: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/q_70/v1642174750/AquaHeat/Navbar%20Images/gas-safe3_az4icv.webp",
      },
    ],
    articles: [
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280239/AquaHeat/Navbar%20Images/boiler-kitchen1_sugw0v.webp",
        subtitle: "GUIDE",
        title: "The Complete Boiler Buying Guide 2021",
        url: "/boiler-buying-guide",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280254/AquaHeat/Navbar%20Images/smartstat2_ayouwd.webp",
        subtitle: "ARTICLE",
        title: "Do Smart Therostats Help Save You Money?",
        url: "/do-smart-thermostats-save-money",
      },
      {
        image:
          "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_200/v1643280217/AquaHeat/Navbar%20Images/bathrooms_uzoqlf.webp",
        subtitle: "ARTICLE",
        title: "Checklist For Planning a New Bathroom",
        url: "/checklist-for-planning-a-new-bathroom",
      },
    ],
  },
];
